import { Routes } from '@angular/router';
import { TERMS_CONFIG } from './base/terms-config';

/**
 * Terms 라우팅 (rxResource 전환)
 *
 * Angular 21+ Modern Pattern:
 * - ❌ Resolver 제거 (느린 라우트 전환 해결)
 * - ✅ Component-level rxResource (즉시 라우트 전환)
 * - ✅ 자동 로딩/에러 상태 관리
 *
 * AS-IS (Resolver):
 * - 라우트 전환 전 데이터 로드 대기 → 느린 UX
 * - runGuardsAndResolvers: 'always'
 * - resolve: { page: termsListResolver }
 *
 * TO-BE (rxResource):
 * - 즉시 라우트 전환 → 빠른 UX
 * - 로딩 스피너 표시 가능
 * - Component-level Signal-based loading
 *
 * 장점:
 * - NgModule → Standalone
 * - Resolver 제거 → UX 개선
 * - Config-Driven
 * - Signal 기반
 * - Type-safe 라우팅
 */
export const termsRoutes: Routes = [
  {
    path: TERMS_CONFIG.routePath,
    data: {
      title: '약관 관리',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/terms-list-page/terms-list-page.component'
          ).then((m) => m.TermsListPageComponent),
        // ✅ rxResource가 자동으로 query params 변경 감지
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/terms-detail-page/terms-detail-page.component'
              ).then((m) => m.TermsDetailPageComponent),
            data: {
              title: '약관 상세',
            },
          },
        ],
      },
    ],
  },
];
